export default "__VITE_ASSET__nqtzDtaF__"